import { MultiStepWizard } from '../MultiStepWizard/MultiStepWizard'
import { MultiStepContentPlanSchema } from '../schemas/ContentPlanSchema'
import { ContentPlanWizardProps } from './Types'
import { ChooseTopic } from './ChooseTopic'
import { ConfirmDetails } from './ConfirmDetails'
import { useState } from 'react'
import { useGenerateContent } from '../Wizard/useGenerateContent'
import { GenerationType } from 'components/BlazeCommandLine/api/createDocGenerationRequest'
import { useCurrentFolderStore } from 'hooks/stores/useCurrentFolderStore'
import { useDefaultFolder } from 'hooks/queries/projects/useDefaultFolder'

export const ContentPlanWizard = ({ onSuccess, ...props }: ContentPlanWizardProps) => {
  const defaultFolder = useDefaultFolder()
  const { currentFolder } = useCurrentFolderStore()
  const [websiteText, setWebsiteText] = useState('')

  const { generateContent } = useGenerateContent({
    generationType: GenerationType.ContentPlan,
    onSuccess,
  })

  const handleSubmit = (values: any) => {
    const { description, key_product_benefits, target_customer_personas, top_product_features, filename, project } =
      values
    const projectValue = project || currentFolder || defaultFolder

    const fields = {
      generation_type: GenerationType.ContentPlan,
      content_plan_description: description,
      content_plan_key_product_benefits: key_product_benefits,
      content_plan_target_customer_personas: target_customer_personas,
      content_plan_top_product_features: top_product_features,
      filename,
      project: projectValue,
    }

    return generateContent(fields)
  }

  return (
    <MultiStepWizard.Root
      {...props}
      schema={MultiStepContentPlanSchema}
      onSubmit={(values) => handleSubmit(values)}
      initialValues={{
        ...props.initialValues,
      }}
    >
      <ChooseTopic setWebsiteText={setWebsiteText} />
      <ConfirmDetails websiteText={websiteText} setWebsiteText={setWebsiteText} />
    </MultiStepWizard.Root>
  )
}
